import Vue from "vue";
import Router from "vue-router";
import { getToken } from "@/utils/auth";
import NProgress from "nprogress";
import store from "@/store";
import { Message } from "element-ui";
Vue.use(Router);

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
let routerReplace = Router.prototype.replace;
// push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err);
};
// replace
Router.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err);
};

const router = new Router({
  base: "/web/",
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth"
      };
    }
    return { x: 0, y: 0 }; // Go to the top of the page if no hash
  },
  // scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      path: "/",
      name: "PageView",
      component: resolve => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home"
        },
        {
          path: "/home",
          name: "home",
          component: resolve => require(["@/view/home/indexNew"], resolve),
          meta: {
            title: "首页"
          }
        },
        {
          path: "/solution",
          name: "solution",
          component: resolve => require(["@/view/solution/index"], resolve),
          meta: {
            title: "产品与解决方案"
          }
        },
        {
          path: "/service",
          name: "service",
          component: resolve => require(["@/view/service/indexNew"], resolve),
          meta: {
            title: "服务能力"
          }
        },
        {
          path: "/aboutUs",
          name: "aboutUs",
          component: resolve => require(["@/view/aboutUs/indexNew"], resolve),
          meta: {
            title: "关于我们"
          }
        },
        {
          path: "/details",
          name: "details",
          component: resolve =>
            require(["@/view/details/caseDetails"], resolve),
          meta: {
            title: "详情"
          }
        },
        
        {
          path: "/Detail",
          name: "Detail",
          component: resolve =>
            require(["@/view/details/SafetyDetail"], resolve),
          meta: {
            title: "详情"
          }
        }
      ]
    },
    {
      path: "/login",
      name: "Login",
      component: resolve => require(["@/view/Login"], resolve)
    },
    {
      path: "/register/:type",
      name: "Register",
      component: resolve => require(["@/view/Register"], resolve)
    },
    {
      path: "/forget",
      name: "Forget",
      component: resolve => require(["@/view/ForgotPassword"], resolve)
    },
    {
      path: "/account",
      name: "account",
      component: resolve => require(["@/view/AccountSecurity"], resolve)
    },
    {
      path: "/:pathMatch(.*)",
      component: resolve => require(["@/view/NotFound"], resolve)
    }
  ]
});
const whiteList = ["/login", "/register"];

// router.beforeEach((to, from, next) => {
//   NProgress.start()
//   if (getToken()) {
//     /* has token*/
//     if (to.path === '/login') {
//       next({ path: '/' })
//       NProgress.done()
//     } else if (whiteList.indexOf(to.path) !== -1) {
//       next()
//       NProgress.done()
//     } else {
//       next()
//       NProgress.done()
//     }
//   } else {
//     // 没有token
//     if (whiteList.indexOf(to.path) !== -1) {
//       // 在免登录白名单，直接进入
//       next()
//       NProgress.done()
//     } else {
//       next(`/login?redirect=${encodeURIComponent(to.fullPath)}`) // 否则全部重定向到登录页
//       NProgress.done()
//     }
//   }
// })

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js